
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.64 19.556c1.6 3.1 4 2.6 7.3 3.1 3.8.5 10.7 1.2 6.3 6.4-1.9 2.4-4.4 4.6-6.7 6.6-1.3 1.1-.9.2-1 1.2-.1 1.2.5 2.8.7 4 .4 2.2 3.2 10.9-1.6 10-2.7-.5-6-3.1-8.4-4.4-2.8-1.4-3.6-.6-6.3.8-2.8 1.5-9.7 6.9-9.6.4.1-2.8 1-5.8 1.5-8.6.5-3 .7-2.1-1.5-4.1-1.7-1.8-9.8-7.3-6.6-10.8 3-3.2 10.3-.1 13.4-3 1.8-1.5 4.4-13.9 8-10.6.1.1.2.2.3.4 1.4 2.9 2.8 5.7 4.2 8.6z"}})])
          )
        }
      }
    